<template>
    <!-- 项目服务流程 -->
    <section class="settled bgw">
        <div class="container">
            <div class="settledWarp">
                <div class="hd">
                    <h3>项目服务流程</h3>
                    <div class="more">
                        <a class="btn minBtn hoverBg" href="#">了解详情</a>
                    </div>
                </div>
                <div class="bd">
                    <ul>
                        <li class="on">
                            <a class="step">
                                <div class="stepNum"></div>
                                <div class="stepName">企业身份验证</div>
                            </a>
                        </li>
                        <li>
                            <a class="step">
                                <div class="stepNum"></div>
                                <div class="stepName">提交数据项目需求</div>
                            </a>
                        </li>
                        <li>
                            <a class="step">
                                <div class="stepNum"></div>
                                <div class="stepName">泰迪服务商提供服务</div>
                            </a>
                        </li>
                        <li>
                            <a class="step">
                                <div class="stepNum"></div>
                                <div class="stepName">线上跟进项目进度</div>
                            </a>
                        </li>
                        <li>
                            <a class="step">
                                <div class="stepNum"></div>
                                <div class="stepName">完成项目需求</div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {

    };
</script>